module.exports = __webpack_public_path__ + "static/super-square.6c7704c1.jpg";